const statusColors = {
  PENDING: '#81B214',
  COMPLETED: '#00AEEF',
  OVERDUE: '#F53434',
};

export {
  statusColors,
};
